export function authHeader() {
    let token = localStorage.getItem('token');
    let headers = {
        'Content-Type': 'application/json',
        'Content-Encoding': 'gzip',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'POST, GET, OPTIONS, PUT, DELETE',
        // 'Access-Control-Allow-Headers': 'Origin, Content-Type, Accept, Authorization, X-Request-With'
    };

    if(token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    return headers;
}